import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/ButtonComponent';
import AccountsStore from '../../stores/AccountsStore';
import RegexUtils from '../../utils/RegexUtils';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import RenameAccountsActionCreator from '../../actions/RenameAccountsActionCreator';
import RenameAccountsStore from '../../stores/RenameAccountsStore';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import LoaderComponent from '../common/LoaderComponent';
import AccountsActionCreator from '../../actions/AccountsActionCreator';

class RenameAccount extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.updateChangedAccountName = this.updateChangedAccountName.bind(this);
    this.displayContent = this.displayContent.bind(this);
    this.actionButtons = this.actionButtons.bind(this);
    this.restoreDefaultAccountName = this.restoreDefaultAccountName.bind(this);
    this.validateChangedAccountName =
      this.validateChangedAccountName.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.getModalBody = this.getModalBody.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.goback = this.goback.bind(this);
    const acc = AccountsStore.getAccountDetail(this.props.accountId);
    this.state = {
      displayName: acc.displayName,
      initialDisplayName: acc.displayName,
      initialProductName: acc.product.name,
      initialMetadataName: acc.metadata.display_name,
      initialAccountOrder: acc.display_order,
      accountShortDescription: acc.product.short_description,
      disableUpdateButton: true,
      showModal: false,
      errorMessage: '',
      showLoader: false,
    };
  }

  componentDidMount() {
    const { renameAccountHeader } = this.props.content;

    sayLandingMessage(renameAccountHeader);
    RenameAccountsStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    RenameAccountsStore.removeChangeListener(this.onStoreChange);
  }

  onChange(e) {
    this.validateChangedAccountName(String(e.target.value));
  }

  onStoreChange() {
    if (RenameAccountsStore.isServiceFail()) {
      this.setState({ showModal: true, showLoader: false, error: true });
    } else {
      AccountsActionCreator.updateAccountsStore(
        RenameAccountsStore.getResponse()
      );
      this.setState({ showModal: true, showLoader: false, error: false });
    }
  }

  getFooter() {
    const { okButtonText } = this.props.content;
    const { error } = this.state;
    const footerButtons = (
      <div>
        <button
          className="c-btn c-btn--default c-modal__button"
          onClick={this.closeModal}
        >
          {okButtonText}
        </button>
      </div>
    );
    return error && footerButtons;
  }

  getModalBody() {
    const { renameAccountSuccess, okButtonText } = this.props.content;
    const { error } = this.state;

    if (error) return RenameAccountsStore.getResponse();
    const successBody = (
      <div className="alerts-success">
        <div>
          <button
            type="submit"
            className="modal-close-btn"
            onClick={this.closeModal}
          >
            Close
          </button>
        </div>
        <svg width="96px" height="96px">
          <use xlinkHref="../images/bow/bow-sprite.svg#icon-success" />
        </svg>
        <label
          ref="acklabel"
          tabIndex="-1"
          className="type--orkney remove-outline"
        >
          {renameAccountSuccess}
        </label>
        <div>
          <button
            type="submit"
            className="c-btn c-btn--default"
            onClick={this.closeModal}
          >
            {okButtonText}
          </button>
        </div>
      </div>
    );

    return successBody;
  }

  actionButtons() {
    const { disableUpdateButton } = this.state;
    const { backText, handleBack } = this.props;

    return (
      <div className="review__options">
        <Button
          btnName={backText}
          className="c-btn c-btn--secondary review__options__back"
          onClick={handleBack}
        />
        &nbsp;&nbsp;
        <Button
          btnName={'Update'}
          className="c-btn c-btn--default review__options__proceed"
          disabled={disableUpdateButton}
          onClick={this.updateChangedAccountName}
        />
      </div>
    );
  }

  closeModal() {
    const { handleBack } = this.props;
    const { error } = this.state;

    !error && handleBack();
    this.setState({ showModal: false });
  }

  displayContent() {
    const { renameAccountNickname } = this.props.content;
    const { displayName } = this.state;

    return (
      <div>
        <div className="c-field" ref="refRename">
          <label
            className="c-field__label c-field__label--block"
            htmlFor="renameAccount"
          >
            {renameAccountNickname}
          </label>
          <div className="c-field__controls">
            <input
              aria-invalid="false"
              aria-required="true"
              className="c-field__input"
              data-parent="refRename"
              type="text"
              name={'renameAccount'}
              id="renameAccount"
              value={displayName}
              maxLength="30"
              minLength="2"
              size="30"
              ref="renameAccount"
              onChange={this.onChange}
            />
          </div>
          {this.displayRestoreLink()}
        </div>
        {this.actionButtons()}
      </div>
    );
  }

  displayRestoreLink() {
    const { initialMetadataName, initialProductName, accountShortDescription } =
      this.state;
    const {
      content: { renameAccountRestore },
    } = this.props;

    let accountNameChanged =
      initialMetadataName && initialMetadataName !== initialProductName;
    if (accountNameChanged) {
      accountNameChanged =
        initialMetadataName && initialMetadataName !== accountShortDescription;
    }

    return (
      accountNameChanged && (
        <p>
          <a
            className="type--uist"
            href="javascript:void(0);"
            onClick={this.restoreDefaultAccountName}
          >
            {renameAccountRestore}
          </a>
        </p>
      )
    );
  }

  goback() {
    this.props.handleBack();
  }

  restoreDefaultAccountName() {
    const { accountShortDescription } = this.state;

    this.setState({ displayName: accountShortDescription });
    this.validateChangedAccountName(accountShortDescription);
  }

  updateChangedAccountName() {
    const { displayName } = this.state;
    const { accountId } = this.props;
    const payload = {
      id: accountId,
      displayName: displayName.trim(),
    };

    RenameAccountsActionCreator.updateAccountName(payload);
    this.setState({ showLoader: true });
  }

  validateChangedAccountName(accountName) {
    const { initialDisplayName } = this.state;
    //get the valid account name
    const validAccountName = accountName.match(
      RegexUtils.regexes.renameAccount
    );
    //replace multiple white spaces with single white space
    let newAccountName = String(validAccountName).replace(
      RegexUtils.regexes.checkMultipleSpace,
      ' '
    );

    let isUpdateButtonDisabled = false;

    if (
      newAccountName === '' ||
      initialDisplayName === newAccountName ||
      newAccountName.length < 2
    ) {
      isUpdateButtonDisabled = true;
    } else if (newAccountName.length > 0 && newAccountName.charAt(0) === ' ') {
      isUpdateButtonDisabled = true;
      newAccountName = newAccountName.trim();
    } else if (
      newAccountName.length === 2 &&
      newAccountName.charAt(1) === ' '
    ) {
      isUpdateButtonDisabled = true;
    }

    this.setState({
      disableUpdateButton: isUpdateButtonDisabled,
      displayName: newAccountName,
    });
  }

  render() {
    const { showLoader, showModal, error } = this.state;

    return (
      <div>
        {showLoader ? <LoaderComponent type="large" /> : this.displayContent()}
        <PatternLibModalComponent
          show={showModal}
          customClass={'c-modal'}
          onHide={this.closeModal}
          bsSize={'medium'}
          modalHeading={''}
          modalBody={this.getModalBody()}
          modalFooter={this.getFooter()}
          modalInContainer={false}
          closeButton={error}
        />
      </div>
    );
  }
}

RenameAccount.propTypes = {
  content: PropTypes.object,
  accountId: PropTypes.string,
  handleBack: PropTypes.func,
  backText: PropTypes.string,
};
export default RenameAccount;
